import Box from "@mui/material/Box";
import ThemeContext from "components/app/Context";
import { filterPage } from "components/common/Filters/FiltersHelper";
import Basictabs from "components/common/Tabs";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect } from "react";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { abovePropertyViewTypePlanTemplate } from "utils/CommonConstants";
import { fetchBookmarkPlan } from "../AboveProperty.slice";
import BookmarkedPlans from "../BookmarkedPlans";
import AssignedLibraryPlans from "./AssignedLibraryPlans";
import AssignedCustomPlans from "./AssignedTemplatePlans";
import BrandDeadline from "./BrandDeadline";
import BrandInitiative from "./BrandInitiatives";
import { setSearchText } from "components/common/Filters/Filters.slice";

const PlanView = () => {
  const translate = useTranslate();
  const { isMobileScreen } = useContext(ThemeContext);
  const tabDetails = [
    {
      label: translate("dashboard.assigned.progress.completed"),
      content: AssignedLibraryPlans,
      filtersToClear: [filterPage.plansPageAssignedPlansDisplay]
    },
    {
      label: translate("dashboard.assigned.templatePlans"),
      content: AssignedCustomPlans,
      filtersToClear: [filterPage.plansPageTemplatePlansDisplay]
    },
    {
      label: translate("dashboard.brand.deadlines"),
      content: BrandDeadline,
      filtersToClear: [filterPage.plansPageBrandDeadlineDisplay]
    },
    {
      label: translate("dashboard.initiatives"),
      content: BrandInitiative,
      filtersToClear: [filterPage.plansPageInitiativesDisplay]
    }
  ];
  const dispatch = useAppDispatch();
  const getBookmarkedplans = async () => {
    await dispatch(fetchBookmarkPlan({ viewType: abovePropertyViewTypePlanTemplate }));
  };
  useEffect(() => {
    getBookmarkedplans();
  }, []);

  return (
    <>
      {isMobileScreen && (
        <>
          <BookmarkedPlans />
          <Box sx={{ mb: "32px" }} />
        </>
      )}
      <Basictabs
        tabDetails={tabDetails}
        labelVariant="body2"
        isChildTab
        backgroundColor={tokens.Background.General.Primary}
        marginBottom="0"
        alignItems="left"
        sx={{ paddingX: "24px" }}
        onTabChangeFn={() => {
          dispatch(setSearchText(""));
          getBookmarkedplans();
        }}
      />
    </>
  );
};

export default PlanView;
